export enum CarType {
  Basic = 'basic',
  Normal = 'normal',
  Large = 'large',
  Premium = 'premium',
}
